import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const options = {
  chart: {
    type: 'pie',
  },
  title: {
    text: 'Distribución por Género',
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>: {point.percentage:.1f}%',
      },
    },
  },
  series: [
    {
      name: 'Género',
      data: [
        {
          name: 'Masculino',
          y: 256,
        },
        {
          name: 'Femenino',
          y: 320,
        },
      ],
    },
  ],
};

const GeneroPieChartPanelControl = () => (
  <HighchartsReact highcharts={Highcharts} options={options} />
);

export default GeneroPieChartPanelControl;
